var _circle, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#E94057"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.104 20.536L32.248 29.512H28.392C27.752 29.512 27.128 29.56 26.52 29.688L28.12 25.848L28.184 25.704L28.28 25.448C28.328 25.336 28.36 25.24 28.408 25.16C30.264 20.856 32.344 19.512 36.104 20.536Z",
    fill: "url(#paint0_linear_13_2534)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.968 29.944L46.936 29.928C45.976 29.656 45 29.512 44.008 29.512H33.992L37.592 21.144L37.64 21.032C37.864 21.112 38.104 21.224 38.344 21.304L41.88 22.792C43.848 23.608 45.224 24.456 46.072 25.48C46.216 25.672 46.344 25.848 46.472 26.056C46.616 26.28 46.728 26.504 46.792 26.744C46.856 26.888 46.904 27.016 46.936 27.16C47.176 27.976 47.192 28.904 46.968 29.944Z",
    fill: "url(#paint1_linear_13_2534)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.032 45.256H37.432C37.912 45.256 38.312 44.824 38.312 44.296C38.312 43.624 38.12 43.528 37.704 43.368L37.032 43.128V45.256Z",
    fill: "url(#paint2_linear_13_2534)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.264 32.232C45.544 32.024 44.792 31.912 44.008 31.912H28.392C27.304 31.912 26.28 32.12 25.32 32.536C22.536 33.736 20.584 36.504 20.584 39.72V42.84C20.584 43.224 20.616 43.592 20.664 43.976C21.016 49.064 23.736 51.784 28.824 52.12C29.192 52.168 29.56 52.2 29.96 52.2H42.44C48.36 52.2 51.48 49.384 51.784 43.784C51.8 43.48 51.816 43.16 51.816 42.84V39.72C51.816 36.184 49.464 33.208 46.264 32.232ZM38.248 41.8C38.984 42.056 39.976 42.6 39.976 44.296C39.976 45.752 38.84 46.92 37.432 46.92H37.032V47.272C37.032 47.736 36.664 48.104 36.2 48.104C35.736 48.104 35.368 47.736 35.368 47.272V46.92H35.224C33.688 46.92 32.424 45.624 32.424 44.024C32.424 43.56 32.792 43.192 33.256 43.192C33.72 43.192 34.088 43.56 34.088 44.024C34.088 44.696 34.6 45.256 35.224 45.256H35.368V42.552L34.152 42.12C33.416 41.864 32.424 41.32 32.424 39.624C32.424 38.168 33.56 37 34.968 37H35.368V36.648C35.368 36.184 35.736 35.816 36.2 35.816C36.664 35.816 37.032 36.184 37.032 36.648V37H37.176C38.712 37 39.976 38.296 39.976 39.896C39.976 40.36 39.608 40.728 39.144 40.728C38.68 40.728 38.312 40.36 38.312 39.896C38.312 39.224 37.8 38.664 37.176 38.664H37.032V41.368L38.248 41.8Z",
    fill: "url(#paint3_linear_13_2534)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.088 39.624C34.088 40.296 34.28 40.392 34.696 40.552L35.368 40.792V38.664H34.968C34.472 38.664 34.088 39.096 34.088 39.624Z",
    fill: "url(#paint4_linear_13_2534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_2534",
    x1: 17.3143,
    y1: 30.5955,
    x2: 40.2113,
    y2: 21.5736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_2534",
    x1: 21.376,
    y1: 30.7973,
    x2: 48.636,
    y2: 15.1418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_2534",
    x1: 35.8025,
    y1: 45.4598,
    x2: 39.1513,
    y2: 44.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_2534",
    x1: -9.41514,
    y1: 54.1425,
    x2: 53.974,
    y2: 16.1166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_2534",
    x1: 32.8585,
    y1: 40.9957,
    x2: 36.2073,
    y2: 40.2108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A2387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#E94057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F27121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPurchase);
export default __webpack_public_path__ + "static/media/img-purchase.185ba15666f30d66236fb388c0d5b0c2.svg";
export { ForwardRef as ReactComponent };